import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-employee-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {

  }

  getEmployee(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + '/api/employeelist/GetEmployee/' + id, this.httpOptions);
  }

  getEmployeeToAdd(): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + '/api/employeelist/GetEmployeeToAdd', this.httpOptions);
  }

  getEmployees(companyId: number): Observable<any> {

      let userId = this.userService.account.EmployeeId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/Get?companyId=${companyId}&userId=${userId}`, this.httpOptions);
  }

  getEmployeesBySearch(departmentIds: number[], supervisorIds: number[], showQuitEmployees): Observable<any> {

      let sDepartmentIds = "";
      departmentIds.forEach(departmentId => {
        sDepartmentIds += "departmentIds=" + departmentId;
        if (departmentId != departmentIds[departmentIds.length - 1]) {
          sDepartmentIds += "&";
        }
      });
      let sSupervisorIds = "";
      supervisorIds.forEach(supervisorId => {
        sSupervisorIds += "supervisorIds=" + supervisorId;
        if (supervisorId != supervisorIds[supervisorIds.length - 1]) {
          sSupervisorIds += "&";
        }
      });
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetEmployees?${sDepartmentIds}&${sSupervisorIds}&showQuitEmployees=${showQuitEmployees}`, this.httpOptions);
  }

  updateEmployee(employee): Observable<any> {
    return this.http.post<any>(this.configService.config.employeeUrl + '/api/employeelist/UpdateEmployee', employee, this.httpOptions);
  }

  updateEmployeeDetail(employee): Observable<any> {
    return this.http.post<any>(this.configService.config.employeeUrl + '/api/employeelist/UpdateEmployeeDetail', employee, this.httpOptions);
  }

  insertEmployee(employee): Observable<any> {
    return this.http.post<any>(this.configService.config.employeeUrl + '/api/employeelist/AddEmployee', employee, this.httpOptions);
  }

  deleteEmployee(employeeId): Observable<any> {
    return this.http.delete<any>(this.configService.config.employeeUrl + '/api/employeelist/DeleteEmployee?employeeId=' + employeeId, this.httpOptions);
  }

  getCalculationMethods(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetCalculationMethods?companyId=${companyId}`, this.httpOptions);
  }

  getSupervisors(): Observable<any> {

    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetSupervisors`, this.httpOptions);
  }

  getGroups(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetGroups?companyId=${companyId}`, this.httpOptions);
  }

  getRoles(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetRoles?companyId=${companyId}`, this.httpOptions);
  }

  getModuleFunctions(): Observable<any> {
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetModuleFunctions`, this.httpOptions);
  }

  insertEmployeeGroup(employeeGroup: any) {
    return this.http.post<any>(this.configService.config.employeeUrl + '/api/employeelist/AddEmployeeGroup', employeeGroup, this.httpOptions);
  }

  getGroupTypes(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetGroupTypes?companyId=${companyId}`, this.httpOptions);
  }

  getSalaryGroups(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetSalaryGroups?companyId=${companyId}`, this.httpOptions);
  }

  getBalanceGroups(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetBalanceGroups?companyId=${companyId}`, this.httpOptions);
  }

  getLanguages():  Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetLanguages`, this.httpOptions);
  }

  getDepartments(): Observable<any> {
      let companyId = this.userService.account.CompanyId;
      return this.http.get<any>(this.configService.config.employeeUrl + `/api/core/GetDepartments`, this.httpOptions);
  }

  getTimeTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + "/api/time/GetTimeTypes", this.httpOptions);
  }

  changeLoginCredentials(currentUsername: string, username: string, password: string, changePasswordAtNextLogin: boolean = true): Observable<any> {
    const params = `?currentUserId=${encodeURIComponent(currentUsername)}&userId=${username}&password=${password}&changepasswordatnextlogin=${changePasswordAtNextLogin}`;

    return this.http
        .patch<any>(`${this.configService.config.directUrl}/api/profiles/changelogincredentials/${params}`, null, this.httpOptions)
        .pipe(map((result: any) => { if (result.IsSuccess) { return result.Data; } throw new Error(result.ErrorMessage); }));
  }

  getSystemParamForDefaultDepartmentSearch(): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeelist/GetSystemValueEmployeeList_FilterDefaultOnUsersDepartment`, this.httpOptions);
  }
}
